import { jsx, Fragment } from 'react/jsx-runtime';
import { useApi, errorApiRef } from '@backstage/core-plugin-api';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import CopyIcon from '@material-ui/icons/FileCopy';
import { useState, useEffect } from 'react';
import useCopyToClipboard from 'react-use/esm/useCopyToClipboard';
import { coreComponentsTranslationRef } from '../../translation.esm.js';
import { useTranslationRef } from '@backstage/core-plugin-api/alpha';

function CopyTextButton(props) {
  const { t } = useTranslationRef(coreComponentsTranslationRef);
  const {
    text,
    tooltipDelay = 1e3,
    tooltipText = t("copyTextButton.tooltipText"),
    "aria-label": ariaLabel = "Copy text"
  } = props;
  const errorApi = useApi(errorApiRef);
  const [open, setOpen] = useState(false);
  const [{ error }, copyToClipboard] = useCopyToClipboard();
  useEffect(() => {
    if (error) {
      errorApi.post(error);
    }
  }, [error, errorApi]);
  const handleCopyClick = (e) => {
    e.stopPropagation();
    setOpen(true);
    copyToClipboard(text);
  };
  return /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx(
    Tooltip,
    {
      id: "copy-test-tooltip",
      title: tooltipText,
      placement: "top",
      leaveDelay: tooltipDelay,
      onClose: () => setOpen(false),
      open,
      children: /* @__PURE__ */ jsx(IconButton, { onClick: handleCopyClick, "aria-label": ariaLabel, children: /* @__PURE__ */ jsx(CopyIcon, {}) })
    }
  ) });
}

export { CopyTextButton };
//# sourceMappingURL=CopyTextButton.esm.js.map
